import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '@/lib/cn'

interface ResponsiveTableProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode
}

/**
 * Wraps a GFM table in a horizontally scrollable container.
 * Used as the `table` component in react-markdown so tables never
 * overflow on narrow viewports.
 */
export function ResponsiveTable({ children, className, ...props }: ResponsiveTableProps) {
  return (
    <div className={cn('my-4 overflow-x-auto rounded-md border border-border', className)} {...props}>
      <table className="min-w-full text-sm">
        {children}
      </table>
    </div>
  )
}
